// Libs
import React from 'react';
import PropTypes from 'prop-types';

// Helpers
import { removePWrap } from '../../../../../helpers/content';

// Styles
import './styles.scss';

// proptypes & context
const propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
};

const defaultProps = {
  title: null,
  subtitle: null,
  children: null,
};

function TitleUnderlined(props) {
  const {
    title,
    subtitle,
    children,
  } = props;
  return (
    <div className="title-underlined">
      { title && <h1 className="title-underlined__main">{title}</h1> }
      { subtitle &&
        <p
          className="title-underlined__subtitle"
          dangerouslySetInnerHTML={{ __html: removePWrap(subtitle) }}
        />
      }
      { children && children }
    </div>
  );
}

TitleUnderlined.propTypes = propTypes;
TitleUnderlined.defaultProps = defaultProps;

export default TitleUnderlined;



// WEBPACK FOOTER //
// ./src/app/components/pages/home/parts/banner/TitleUnderlined.js